<script setup>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import WootModal from 'dashboard/components/Modal.vue';
import ContactTypeahead from './ContactTypeahead.vue';

const props = defineProps({ appointment: { type: Object, required: true } });
const emit = defineEmits(['close']);
const store = useStore();
const { t } = useI18n();

const show = ref(true);

const close = () => {
  show.value = false;
  emit('close');
};

const onPick = async contactId => {
  if (!contactId) return;
  try {
    await store.dispatch('painelAppointments/linkContact', {
      id: props.appointment.id,
      contactId,
    });
    close();
  } catch {
    // dispatch failed — modal stays open so user can retry
  }
};
</script>

<template>
  <WootModal v-model:show="show" @close="close">
    <div class="w-96 p-6">
      <h2 class="mb-4 text-lg font-semibold">
        {{ t('PAINEL.APPOINTMENTS.LINK_CONTACT') }}
      </h2>
      <ContactTypeahead
        :placeholder="t('PAINEL.APPOINTMENTS.SEARCH_PLACEHOLDER')"
        @update:model-value="onPick"
      />
    </div>
  </WootModal>
</template>
